import './util/svgSpriteUtil';
import { Plugins, Common } from "./components";


$(document).ready(() => {
  // execute common scripts
  Common.run();
});



// WEBPACK FOOTER //
// ./assets/scripts/main.js